import { getTimeStamp } from '../utilis/getTimeStamp';
import { userComApiSendEvent } from '../api';
import { getDayDiscount } from '../utilis/getDayDiscount';
import { getDietDailyCostAfterDaysDiscountPerSetDay } from '../utilis/getDietDailyCostPerSetDay';
import { getDeliveryTime } from '../utilis/getDeliveryTime';
import { createSideOrdersArray } from '../utilis/createSideOrdersArray';
import { sideOrdersPriceCount } from '../utilis/sideOrdersPriceCount';

export const userComAddEvent = (
  orderForm,
  selectedCity,
  userCom,
  chooseSideOrders
) => {
  const {
    days,
    mealExchange: { days: daysList, totalPrice },
    selectedCalories: { calories },
    selectedDays,
    selectedDiet: { dietId, dietName, discounts },
    selectedDietCaloriesIdPrices,
    selectedMeals,
    selectedOption: { dietOptionName },
    sets,
    testOrder,
  } = orderForm;
  const { name, sectorId } = selectedCity;

  const dayDiscount = getDayDiscount(discounts, days);

  const dietCostPerSetDay = selectedDietCaloriesIdPrices.find(
    price => price.sectorId === sectorId
  ).price;

  const dietCostAfterDaysDiscountPerSetDay =
    getDietDailyCostAfterDaysDiscountPerSetDay(dietCostPerSetDay, dayDiscount);

  const priceOfSideOrders = chooseSideOrders.priceOfSideOrders;
  const priceOfSideOrdersMenuConf = totalPrice.sideOrdersPriceSum;

  const data = {
    client: userCom.userId,
    data: {
      //   additional_information: orderNote - nie ma tego w formularzu
      address_city: name,
      //   address_street: street - nie ma dostępu w formularzu na tym etapie
      calories: calories,
      daily_meals: selectedMeals?.length || 0,
      delivery_time_beginning: `${getDeliveryTime(
        Math.min.apply(null, selectedDays)
      )} 03:00:00`,
      delivery_time_days: days,
      delivery_time_end: `${getDeliveryTime(
        Math.max.apply(null, selectedDays)
      )} 22:00:00`,
      diet_name: dietName,
      product_id: dietId,
      product_name: dietName,
      quantity: sets,
      side_orders: createSideOrdersArray(daysList) || [],
      trial: testOrder,
      URL: window.location.origin,
      value:
        dietCostPerSetDay * days +
        sideOrdersPriceCount(priceOfSideOrders, priceOfSideOrdersMenuConf),
      valueAfterDaysDiscount:
        dietCostAfterDaysDiscountPerSetDay * days +
        sideOrdersPriceCount(priceOfSideOrders, priceOfSideOrdersMenuConf),
      variant: dietOptionName,
    },
    name: 'add',
    timestamp: getTimeStamp(),
  };
  userComApiSendEvent(data, userCom).catch(e => console.log(e));
};
